import React, { useEffect, useMemo, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { BPagination } from '../../shared/Pagination';
import moment from 'moment';

export const ZoomCleanLogGrid = (props) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [paginatedData, setPaginatedData] = useState([]);
    const items = useMemo(() => props.items, [props.items]);

    useEffect(() => {
        setCurrentPage(1);
        const result = paginateData({ data: items, currentPage, itemsPerPage });
        setPaginatedData(result);
    }, [items]);

    const handlePaginate = (pageNumber) => {
        setCurrentPage(pageNumber);
        const result = paginateData({ data: items, currentPage: pageNumber, itemsPerPage });
        setPaginatedData(result);
    };

    const paginateData = ({ data, currentPage, itemsPerPage }) => {
        const indexOfLastItem = currentPage * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;

        return data.slice(indexOfFirstItem, indexOfLastItem);
    };


    return (<>
        <Row>
            <Col>
                <div className="table-responsive">
                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <th scope="col">Number of licenses assigned prior to execution</th>
                                <th scope="col">Number of licenses assigned after execution</th>
                                <th scope="col">Number of available licenses before</th>
                                <th scope="col">Number of available licenses after</th>
                                <th scope="col">DateTime Execution</th>
                                <th scope="col">Email list of affected users</th>
                            </tr>
                        </thead>
                        <tbody>

                            {(paginatedData || []).map((item, idx) => (<tr key={idx}>
                                <td scope="col">{item.assignedLicensesBefore}</td>
                                <td scope="col">{item.assignedLicensesAfter}</td>
                                <td scope="col">{item.availableLicensesBefore}</td>
                                <td scope="col">{item.availableLicensesAfter}</td>
                                {/* <td scope="col">{item.freeLicense}</td> */}
                                {/*<td scope="col">{`${moment.utc(item.eventTimestamp).local().format('L')} ${moment.utc(item.eventTimestamp).local().format('LTS')}`}*/}
                                {/* <td scope="col">{`${moment.utc(item.eventTimestamp).local().format('MM/DD/YYYY hh:mm:ss a')}`} */}
                                <td scope="col">{`${moment.utc(item.eventTimestamp).format('MM/DD/YYYY hh:mm:ss a')}`}
                                    {/* moment.utc(item.eventTimestamp).subtract(7, 'hours').format('MM/DD/YYYY hh:mm:ss a'); */}
                                </td>
                                <td scope="col">
                                    {/* <ul className="list-group  list-group-flush bg-transparent border border-0">
                                        {item.users?.split(' ').slice(0, 5).map(i => <li key={`${idx}_${i}`}
                                            className="list-group-item bg-transparent border border-0  p-0 m-1">{i}</li>)}
                                        {item.users?.split(' ').length > 5 ? (
                                            <li className="list-group-item bg-transparent border border-0 text-muted"> ... {item.users?.split(' ').length - 5} more
                                                records.</li>) : <></>}
                                    </ul> */}
                                    <ul className="list-group list-group-flush bg-transparent border border-0">
                                        {item.users?.split(' ').slice(0, 5).map(i => {
                                            if (i.trim() !== '') {
                                                return (
                                                    <li key={`${idx}_${i}`} className="list-group-item bg-transparent border border-0 p-0 m-1">
                                                        {i}
                                                    </li>
                                                );
                                            }
                                            return null;
                                        })}
                                        {item.users?.split(' ').length > 5 ? (
                                            <li className="list-group-item bg-transparent border border-0 text-muted">
                                                ... {item.users?.split(' ').length - 5} more records.
                                            </li>
                                        ) : (
                                            <></>
                                        )}
                                    </ul>
                                </td>
                            </tr>))}
                        </tbody>
                    </table>
                </div>
            </Col>
        </Row>
        <Row>
            <Col>
                <div className="row">
                    <div className="col-md-4 offset-md-8">
                        <BPagination paginate={(pageNumber) => handlePaginate(pageNumber)}
                            currentPage={currentPage}
                            itemsPerPage={itemsPerPage}
                            totalItems={items?.length || 0} />
                    </div>
                </div>
            </Col>
        </Row>
    </>);
};
